import { render, staticRenderFns } from "./CopOrderEditComponent.vue?vue&type=template&id=dad9596c"
import script from "./CopOrderEditComponent.vue?vue&type=script&lang=js"
export * from "./CopOrderEditComponent.vue?vue&type=script&lang=js"
import style0 from "./CopOrderEditComponent.vue?vue&type=style&index=0&id=dad9596c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports